import { useGetPaymentMethod } from '@api/lendingAPI/useGetPaymentMethod';

// Reads the registered repayment card's last 4 digits for the completed view.
// Suspends until the payment methods are loaded.
export function useGetCompletedDebitCard() {
    const { data } = useGetPaymentMethod({
        suspense: true,
        select: (response) => {
            const card = response.data?.find(
                (method) => method.payment_method_type === 'card'
            );

            return { lastDigits: card?.last_digits };
        }
    });

    return { lastDigits: data?.lastDigits };
}
